import type { LanguageRegistration } from 'shiki'

import generatedGrammar from './fplusGrammar.generated.json'

export const fplusScopeName = generatedGrammar.scopeName

/**
 * The F-plus TextMate grammar, generated from the ANTLR lexer grammar by
 * `yarn workspace @festina-life/fplus-monaco textmate:grammar`. Edit the lexer
 * grammar, or the generator, and regenerate — never the generated file.
 */
export function createFPlusGrammar(languageId: string): LanguageRegistration {
  return {
    ...generatedGrammar,
    name: languageId,
  }
}
